module.exports = __webpack_public_path__ + "static/media/Logo.87903360.png";